export default __webpack_public_path__ + "static/media/unlockStatsDark.2321c943.png";